import { isAxiosError } from 'axios';
import { axiosAuth } from '@/axios';
import { Endpoints } from '@/enums';

type UserData = {
  userName: string;
  fullName: string;
  email: string;
  phone: string;
};

export const registerUser = async (userData: UserData): Promise<unknown> => {
  try {
    const res = await axiosAuth.post(Endpoints.SignUp, {
      ...userData,
    });
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
